/* global Search */

if (document.querySelector(".fbjs-search")) {
    const mySearch = new Search.default({
        url: "https://dxp-uk-search.funnelback.squiz.cloud/s/search.json",
        collections: ["wood~sp-combined-meta"],
        additionalFBparams: {
            profile: "_default",
            nodup: "1",
        },
        onFiltersUpdate: () => {
            var allResultsLabel = document.querySelector(
                    ".search__facet-item--all"
                ),
                facetsSelctor = document.querySelectorAll(
                    ".search__facet-input"
                ),
                facetsLabelsSelctor = document.querySelectorAll(
                    ".search__facet-label"
                ),
                highlightAllResults = true,
                checkedParam = 'checked="checked"';

            /**
             * @desc If any of facets are mot selected, select All results
             */
            [...facetsSelctor].map((el) => {
                el.checked == true ? (highlightAllResults = false) : "";
            });

            var facetTemplateAll = `<label class="search__facet-label">
                <input
                class="search__facet-input"
                type="checkbox"
                value=""
                name="All results"
                id="facet--all-results-js"
                data-fparam="f.section|section"
                ${highlightAllResults ? checkedParam : ""}
                />
                <span class="search__facet-span">All results</span>
            </label>`;

            if (allResultsLabel) {
                // add template All results
                allResultsLabel.innerHTML = facetTemplateAll;

                /**
                 * @desc If client will click All results, script will unselect opened facet by clicking it again
                 */
                allResultsLabel.addEventListener("click", (e) => {
                    e.preventDefault();

                    var selectedItem = [...facetsSelctor].filter(
                        (el) => el.checked == true
                    );
                    selectedItem.length ? selectedItem[0].click() : "";
                });
            }

            [...facetsLabelsSelctor].map((el) => {
                el.addEventListener("click", () => {
                    var elmnt = document.querySelector(".search__form");
                    elmnt.scrollIntoView();
                });
            });
        },
        results: {
            numRanks: 10,
        },

        facets: {
            items: [
                {
                    name: "section",
                    type: "checkbox",
                    options: {
                        singleChoice: true,
                        facetsRestricted: false,
                    },
                },
            ],
        },
        activeFacetsOnStart: {
            "f.section|section": [],
        },
        pagination: {
            loadMore: false,
            arrows: true,
            arrowsOnEdgePages: true,
            dots: false,
            edgePages: false,
            pages: 0,
        },

        templates: {
            articleTemplate: (fields) => {
                var url = fields.clickTrackingUrl
                    ? `https://dxp-uk-search.funnelback.squiz.cloud${fields.clickTrackingUrl}`
                    : "";
                var title = fields.listMetadata.t
                    ? `<h2 class="search__item-title">${fields.listMetadata.t}</h2>`
                    : "";
                var desc = fields.listMetadata.description
                    ? `<p class="search__item-paragraph">${fields.listMetadata.description}</p>`
                    : "";

                var breadcrumbs = fields.listMetadata?.breadcrumbs?.[0]
                    ? fields.listMetadata.breadcrumbs[0].replace("Home", "Wood")
                    : "";
                var titleAttr = fields.title.length > 0 ? true : false;
                if (titleAttr) {
                    return `
                <div>
                    <a href="${url}" class="search__item">${title}</a>
                    ${desc}
                    ${breadcrumbs}
                </div>
                `;
                }
                return "";
            },
            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: (fields, resultsSummary) => {
                return `
                <p class="search__summary">
                    Showing ${resultsSummary.currStart}-${resultsSummary.currEnd} of ${resultsSummary.totalMatching}
                </p>
                `;
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                // name="query"
                // class="search-input-field"
                return `
                <div>
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Search..."
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            autofocus="autofocus"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                </div>
                `;
            },
            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startRank
             * @returns {string}
             **/
            paginationNumberTemplate: () => {
                return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },
            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/
            activePaginationNumberTemplate: () => {
                return ""; //<li class="search__active-page hidden">${number}</li>
            },
            /**
             * @name arrowNextTemplate
             * @param startrank
             * @returns {string}
             **/
            arrowNextTemplate: (startrank) => {
                return `<button class="btn btn--listing-next" data-startrank=${startrank}>Next</button>`;
            },
            /**
             * @name arrowPrevTemplate
             * @param startrank
             * @returns {string}
             **/
            arrowPrevTemplate: (startrank) => {
                return `<button class="btn btn--listing-previous" data-startrank=${startrank}>Previous</button>`;
            },
            /**
             * @name paginationTemplate
             * @param pages
             * @returns {string}
             **/
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },
            // eslint-disable-next-line no-unused-vars
            facetCheckbox: (fields, activeFacets, h) => {
                //{name, label}, activeFacets
                // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                fields.allValues.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${
                                        activeFacets[
                                            "f.section|section"
                                        ]?.value.includes(item.data)
                                            ? "checked='checked'"
                                            : ""
                                    }

                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="f.section|section"
                                    data-singlechoice="true"

                                    />
                                    <span class="search__facet-span">${
                                        item.label
                                    }</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },
            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                // let spellSuggestion = "";
                // if (spell.text) {
                //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                // }
                return "<div>We're sorry, we couldn't find anything matching .</div>";
            },
        },
    });

    mySearch.init();
}
